import React from 'react';
import PropTypes from 'prop-types';
import useCookieConsent from 'utils/cookieConsent';
import { ContentBoxContainer, ContentBoxText, PageContent, Query, PenlySeo } from 'components';
import cookie from 'cookie';

import COOKIES_PAGE_QUERY from 'queries/pages/cookies';

function Cookies({ cookies }) {
    const [ cookieConsent, setCookieConsent ] = useCookieConsent();

    const isServer = typeof window === 'undefined';

    let descText = 'Du har ikke accepteret';
    let buttonText = 'Acceptér';
    if ((isServer && cookies.CookieConsent === 'true') || cookieConsent) {
        descText = 'Du har accepteret';
        buttonText = 'Fjern accept';
    }

    return (
        <>
            <PenlySeo noindex={ true } />
            <Query query={ COOKIES_PAGE_QUERY }>
                { ({ data: { cookiesPage } }) => <PageContent { ...cookiesPage.content } /> }
            </Query>
            <ContentBoxContainer>
                <ContentBoxText style={{ paddingTop: 20 }}>
                    <p htmlFor="optout" style={{ fontWeight: 'bold' }}>
                        { descText }
                    </p>
                    <button onClick={ () => setCookieConsent(!cookieConsent) }>{ buttonText }</button>
                </ContentBoxText>
            </ContentBoxContainer>
        </>
    );
}

Cookies.propTypes = {
    cookies: PropTypes.object,
};

function parseCookies(req) {
    if (!req || !req.headers) {
        return {};
    }
    return cookie.parse(req.headers.cookie || '');
}

export async function getServerSideProps(context) {
    return { props: { cookies: parseCookies(context?.req) } };
}

export default Cookies;
